import React from "react";

function ActiveDashboardIcon({fill}) {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 1.5V6C7.5 6.3978 7.342 6.7794 7.0607 7.0607C6.7794 7.342 6.3978 7.5 6 7.5H1.5C1.10218 7.5 0.72064 7.342 0.43934 7.0607C0.15804 6.7794 0 6.3978 0 6V1.5C0 1.10218 0.15804 0.72064 0.43934 0.43934C0.72064 0.15804 1.10218 0 1.5 0H6C6.3978 0 6.7794 0.15804 7.0607 0.43934C7.342 0.72064 7.5 1.10218 7.5 1.5ZM15 0H10.5C10.1022 0 9.7206 0.15804 9.4393 0.43934C9.158 0.72064 9 1.10218 9 1.5V6C9 6.3978 9.158 6.7794 9.4393 7.0607C9.7206 7.342 10.1022 7.5 10.5 7.5H15C15.3978 7.5 15.7794 7.342 16.0607 7.0607C16.342 6.7794 16.5 6.3978 16.5 6V1.5C16.5 1.10218 16.342 0.72064 16.0607 0.43934C15.7794 0.15804 15.3978 0 15 0ZM6 9H1.5C1.10218 9 0.72064 9.158 0.43934 9.4393C0.15804 9.7206 0 10.1022 0 10.5V15C0 15.3978 0.15804 15.7794 0.43934 16.0607C0.72064 16.342 1.10218 16.5 1.5 16.5H6C6.3978 16.5 6.7794 16.342 7.0607 16.0607C7.342 15.7794 7.5 15.3978 7.5 15V10.5C7.5 10.1022 7.342 9.7206 7.0607 9.4393C6.7794 9.158 6.3978 9 6 9ZM15 9H10.5C10.1022 9 9.7206 9.158 9.4393 9.4393C9.158 9.7206 9 10.1022 9 10.5V15C9 15.3978 9.158 15.7794 9.4393 16.0607C9.7206 16.342 10.1022 16.5 10.5 16.5H15C15.3978 16.5 15.7794 16.342 16.0607 16.0607C16.342 15.7794 16.5 15.3978 16.5 15V10.5C16.5 10.1022 16.342 9.7206 16.0607 9.4393C15.7794 9.158 15.3978 9 15 9Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default ActiveDashboardIcon;
